import { Component, OnInit, ViewChild } from '@angular/core';
import { UtilsService } from '../../services/utils.service';
import { DataCombo } from '../../models/combo';
import { ClienteService } from '../../services/cliente.service';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-accesos-directos',
  templateUrl: './accesos-directos.component.html',
  styleUrls: ['./accesos-directos.component.scss']
})
export class AccesosDirectosComponent implements OnInit {
  @ViewChild('clienteSelect') clienteSelect: NgSelectComponent;

  clientesCombo: DataCombo[] = [];
  selectedClienteId: any = null;
  public loading = false;
  public isModalFormTkOpen: boolean = false;
  public tiendaId: number;

  constructor(
    private clienteService: ClienteService,
    private utilsService: UtilsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.tiendaId = this.utilsService.getCurrentTiendaId();
    this.loadClientes();
  }

  // crear ticket
  crearTicket(): void {
    this.isModalFormTkOpen = true;
  }

  closeFormTkModal(): void {
    this.isModalFormTkOpen = false;
  }

  cambiarTienda(): void {
    this.utilsService.clearCurrentTiendaId();
    this.router.navigate(['/main']);
  }

  // updateToastMsg(event: any): void {
  //   if (event.mensajeError) {
  //     this.toastService.mostrarMensajeError(event.mensaje);
  //   } else {
  //     this.toastService.mostrarMensajeOK(event.mensaje);
  //   }
  // }

  // clientes
  private loadClientes() {
    this.loading = true;
    this.clienteService.getClientesCombo(this.tiendaId)
      .pipe(take(1))
      .subscribe(clientes => {
        this.clientesCombo = clientes;
        this.loading = false;
      });
  }

  toggleSelect() {
    if (this.clienteSelect) {
      this.clienteSelect.open();
    }
  }

  onClienteChange(event: any) {
    if (event?.value) {
      this.router.navigate(['/clientes/', event.value]);
      this.clienteSelect.clearModel();
    }
  }

  onOpen() {
    const selectorEl = document.querySelector('.selector-flotante');
    selectorEl?.classList.add('visible');

    // Hacer focus en el input de búsqueda del ng-select
    setTimeout(() => {
      if (this.clienteSelect && this.clienteSelect.searchInput) {
        this.clienteSelect.searchInput.nativeElement.focus();
      }
    }, 100);
  }

  onClose() {
    const selectorEl = document.querySelector('.selector-flotante');
    selectorEl?.classList.remove('visible');
  }
}
